export default __webpack_public_path__ + "static/media/russia.7f4b2241.svg";